import { mapGetters, mapActions } from "vuex";

export default {
  props: {
    active_text: {
      required: true,
      type: String,
    },
    inactive_text: {
      required: true,
      type: String,
    },
    button_name: {
      required: false,
      default: "",
      type: String,
    },
    button_class: {
      required: false,
      default: "btn-primary",
      type: String,
    },
  },
  computed: {
    ...mapGetters({
      disabled: "checkout/buttonsDisabled",
      pointerEvent: "checkout/pointerEvent",
    }),
  },
  methods: {
    ...mapActions({
      setButtonsDisabled: "checkout/setButtonsDisabled",
      setPointerEvent: "checkout/setPointerEvent",
    }),
  },
};
